var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"text-sm text-gray-500"},[_vm._v("아래 관련된 정보를 먼저 삭제 또는 변경 바랍니다.")]),_c('ol',{staticClass:"mb-12"},_vm._l((_vm.sameEntityInvestments),function(investment){return _c('li',{key:`same-entity-investment-${investment.id}`,staticClass:"py-2"},[_vm._v(" "+_vm._s(investment.investment_name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }